import React from 'react';
import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import AgentQATab from './tabs/AgentQA';
import TranslationBank from './tabs/TranslationBank';

const AgentQA: React.FC = () => {
  return (
    <ModuleContainer>
      <ItemTabs tabNames={['Agent QA', 'Translation Bank']}>
        <AgentQATab />
        <TranslationBank />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default AgentQA;
